export const TapEvent = Object.freeze({
  TAP: "tap",
  DOUBLE_TAP: "double_tap",
});
